import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
    Row,
    Col,
    Button
} from "reactstrap";
import ProductionConsumptionGraph from './Results/ProductionConsumptionGraph';
import { PDFDocument, StandardFonts } from 'pdf-lib';
import ResultsModal from './Results/ResultsModal';
import CashFlowGraph from './Results/CashFlowGraph';
import MainService from 'services/MainService';
import { Box, LinearProgress } from '@mui/material';

import CalculatorService from 'services/CalculatorService';
import PDFService from 'services/PDFService';

import householdsReportSerbianPDF from '../../assets/pdf-templates/households-report-serbian.pdf'
import householdsReportFrenchPDF from '../../assets/pdf-templates/households-report-french.pdf'
import householdsReportEnglishPDF from '../../assets/pdf-templates/households-report-english.pdf'
import { t } from 'i18next';

function prepareDataForCashFlowDiagram(data) {
    let out = [];
    let thisYear = new Date().getFullYear();
    for (let i = 0; i < data.length; i++) {
        out.push({ "EUR": data[i], "year": thisYear + i });
    }
    return out;
}

// function getMounthlyEm(data) {
//     return data["outputs"]["monthly"]["fixed"];
// }

// function getData() {
//     return {
//         investorHeadingField: "Ivan Mladenovic Investment LTD",
//         investorField: "Ivan Mladenovic",
//         addressField: "44.787197, 20.457273",
//         rooftopSlopeField: "30",
//         roofAzimuthField: "45",
//         annualEnergyConsumptionField: "360",
//         estimatedPowerFNEField: "500",
//         estimatedAnnualEnergyProductionField: "8000",
//         estimatedInvestmentValueFromField: "1.000.000",
//         estimatedInvestmentValueToField: "10.000.000",
//         estimatedReturnOnInvestmentField: "2",
//     }
// }

// function prepareDataForPDF(data, investitor) {
//     return {
//         investorHeadingField: investitor,
//         investorField: investitor,
//         addressField: `${MainService.degToDMS(data.inputs.lat)}, ${MainService.degToDMS(data.inputs.lon)}`,
//         rooftopSlopeField: data.inputs.angle,
//         roofAzimuthField: data.inputs.aspect,
//         annualEnergyConsumptionField: data.inputs.consumption,
//         estimatedPowerFNEField: (Math.round(data.results.power * 100) / 100).toString(),
//         estimatedAnnualEnergyProductionField: (Math.round(data.results.production)).toString(),
//         estimatedInvestmentValueFromField: (Math.round(data.results.min_price)).toString(),
//         estimatedInvestmentValueToField: (Math.round(data.results.max_price)).toString(),
//         estimatedReturnOnInvestmentField: (Math.round(data.results.roi * 10) / 10).toString(),
//         surfaceField: Math.ceil(data.results.used_area),
//         savings_kwh: Math.round(data.results.savings_kwh),
//         savings_eur: Math.round(data.results.savings_eur).toString(),
//         savings_eur_exploitation_period: Math.round(data.results.savings_eur_exploitation_period).toString(),
//         maintenance_annualy: Math.round(data.results.maintenance_annualy),
//         savings_co2_exploitation_period: Math.round(data.results.savings_co2_exploitation_period),
//     }
// }

// function setText(form, data) {

//     /**
//      * Getting fields
//      */

//     // 1st page
//     const investorHeadingField = form.getTextField('investorHeadingField');

//     // 3th page

//     // Input data
//     const investorField = form.getTextField('investorField');
//     const addressField = form.getTextField('addressField');
//     const rooftopSlopeField = form.getTextField('rooftopSlopeField');
//     const roofAzimuthField = form.getTextField('roofAzimuthField');
//     const annualEnergyConsumptionField = form.getTextField('annualEnergyConsumptionField');

//     // Output data
//     const estimatedPowerFNEField = form.getTextField('estimatedPowerFNEField');
//     const estimatedAnnualEnergyProductionField = form.getTextField('estimatedAnnualEnergyProductionField');
//     const surfaceField = form.getTextField('surfaceField');
//     const estimatedInvestmentValueFromField = form.getTextField('estimatedInvestmentValueFromField');
//     const estimatedInvestmentValueToField = form.getTextField('estimatedInvestmentValueToField');
//     const estimatedReturnOnInvestmentField = form.getTextField('estimatedReturnOnInvestmentField');
//     const energySavingsField = form.getTextField('energySavingsField');
//     const eurSavingField = form.getTextField('eurSavingField');
//     const totalEurSavingField = form.getTextField('totalEurSavingField');
//     const maintenanceField = form.getTextField('maintenanceField');
//     const co2SavingsField = form.getTextField('co2SavingsField');

//     // Fill in the basic info fields
//     investorHeadingField.setText(data.investorHeadingField);

//     investorField.setText(data.investorField);
//     addressField.setText(data.addressField);
//     rooftopSlopeField.setText(data.rooftopSlopeField + "");
//     roofAzimuthField.setText(data.roofAzimuthField + "");
//     annualEnergyConsumptionField.setText(data.annualEnergyConsumptionField + "");


//     estimatedPowerFNEField.setText(data.estimatedPowerFNEField + "");
//     estimatedAnnualEnergyProductionField.setText(data.estimatedAnnualEnergyProductionField + "");
//     surfaceField.setText(data.surfaceField + "");
//     estimatedInvestmentValueFromField.setText(data.estimatedInvestmentValueFromField + "");
//     estimatedInvestmentValueToField.setText(data.estimatedInvestmentValueToField + "");
//     estimatedReturnOnInvestmentField.setText(data.estimatedReturnOnInvestmentField + "");
//     energySavingsField.setText(data.savings_kwh + "");
//     eurSavingField.setText(data.savings_eur + "");
//     totalEurSavingField.setText(data.savings_eur_exploitation_period + "");
//     maintenanceField.setText(data.maintenance_annualy + "");
//     co2SavingsField.setText(data.savings_co2_exploitation_period + "");
// }

function HouseholdsResults(props) {

    /**
     * Production Consumption Graph = PCG
     * Cash Flow Graph = CFG
     */

    const [phase, setPhase] = useState("none");
    const [pcgPNG, setPcgPNG] = useState(null);
    const [cfgPNG, setCfgPNG] = useState(null);
    const [recievedData, setRecievedData] = useState(null);

    const obj = {
        "inputs": {
            "lat": "45",
            "lon": "8",
            "peakpower": "1",
            "aspect": "65",
            "angle": "25",
            "consumption": "200",
            "roof_area": "100",
            "mountingplace": "building",
            "loss": "10"
        },
        "results": {
            "months": [
                {
                    "month": "January",
                    "E_m": 49.79
                },
                {
                    "month": "February",
                    "E_m": 64.32
                },
                {
                    "month": "March",
                    "E_m": 106.84
                },
                {
                    "month": "April",
                    "E_m": 120.52
                },
                {
                    "month": "May",
                    "E_m": 142.91
                },
                {
                    "month": "June",
                    "E_m": 150.54
                },
                {
                    "month": "July",
                    "E_m": 161.81
                },
                {
                    "month": "August",
                    "E_m": 143.14
                },
                {
                    "month": "September",
                    "E_m": 110.16
                },
                {
                    "month": "October",
                    "E_m": 77.06
                },
                {
                    "month": "November",
                    "E_m": 46.91
                },
                {
                    "month": "December",
                    "E_m": 45.13
                }
            ],
            "power": 0.16405141371305765,
            "used_area": 100,
            "roi": 13.22995271879497,
            "min_price": 131.2411309704461,
            "max_price": 196.86169645566918,
            "production": 200,
            "max_production": 161.81,
            "recommended_power": 0.16405141371305765,
            "annual_production": 1219.13,
            "conclusion": "The recommended power for your system is 0.16405141371305765 kWp"
        }
    };

    const obj2 = { "inputs": { "lat": 44.80369346402062, "lon": 20.460581313571264, "peakpower": "1", "aspect": 0, "angle": 10, "consumption": 5000, "roof_area": 1000, "mountingplace": "building", "loss": "10" }, "results": { "months": [{ "month": "January", "E_m": 173.23393067183284 }, { "month": "February", "E_m": 217.42890749325397 }, { "month": "March", "E_m": 401.9061786480315 }, { "month": "April", "E_m": 511.57199197398455 }, { "month": "May", "E_m": 595.1186604857123 }, { "month": "June", "E_m": 622.3621393482321 }, { "month": "July", "E_m": 682.1248183768075 }, { "month": "August", "E_m": 611.7242095066767 }, { "month": "September", "E_m": 451.6363384764408 }, { "month": "October", "E_m": 350.3597868954542 }, { "month": "November", "E_m": 232.60741714522933 }, { "month": "December", "E_m": 149.9256209783436 }], "power": 4.324361724209506, "used_area": 100, "roi": 14.1231153, "min_price": 3459.489379367605, "max_price": 5189.2340690514075, "production": 5000.0, "recommended_power": 4.324361724209506, "conclusion": "Enough space for recommended power", "production_year": [4900.0, 4873.05, 4846.248225, 4819.593859762501, 4793.086093533808, 4766.724120019372, 4740.5071373592655, 4714.4343481037895, 4688.504959189219, 4662.718181913679, 4637.073231913154, 4611.569329137632, 4586.205697827375, 4560.981566489325, 4535.896167873634, 4510.948738950329, 4486.138520886103, 4461.46475902123, 4436.926702846613, 4412.523605980957, 4388.254726148061, 4364.119325154247, 4340.116668865899, 4316.246027187137, 4292.506674037608, 4268.897887330401, 4245.418948950084, 4222.069144730859, 4198.8477644348395, 4175.754101730448], "bilance": [-4324.361724209506, -3735.209979209506, -3149.2985688070057, -2566.6096711617192, -1987.125562453482, -1410.8286163431399, -837.7013034364047, -267.72619075065654, 299.11405881532005, 862.8366870086837, 1423.4588407469842, 1980.9975726397238, 2535.4698415070534, 3086.8925128956125, 3635.2823595915347, 4180.65606213063, 4723.03020930576, 5262.4212986714265, 5798.845737045582, 6332.319841008679, 6862.859837399979, 7390.481863811128, 7915.201969077016, 8437.036113763941, 8956.000170655088, 9472.109925233333, 9985.381076161399, 10495.82923575936, 11003.469930479532, 11508.318601378744], "savings_kwh": 4900.0, "savings_eur": 592.41, "savings_eur_exploitation_period": 16425.090325588248, "maintenance_annualy": 86.48723448419013, "savings_co2_exploitation_period": 160.31105528696554 } };

    useEffect(() => {

        if (props.start && phase == "none") {
            setPhase("calculating");
            sendRequest();
        }

        // if (recievedData == null && phase == "none") {
        //     setPhase("finished");
        //     setRecievedData(obj);
        // }

    });

    function sendRequest() {

        // setRecievedData(obj2);
        // setPhase("finished");
        // scrollToResults();
        // return;

        let data = {
            lat: props.inputValues.latitude,
            lon: props.inputValues.longitude,
            roof_area: parseInt(props.inputValues.surface),
            aspect: props.inputValues.aspect,
            angle: props.inputValues.angle,
            consumption: parseInt(props.inputValues.consumption)
        }

        CalculatorService.householdsCalculation(data)
            .then(function (response) {
                setRecievedData(response.data);
                setPhase("finished");
                scrollToResults();
            })
            .catch(function (error) {
                alert("Greska");
                console.log(error);
                setPhase("finished");
            });
    }

    function scrollToResults() {
        const timer = setInterval(() => {
            const element = document.getElementById('basic-calculator-results');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                clearInterval(timer);
            }
        }, 400);
    };

    // function setPNG(pngObject) {
    //     setPcgPNG(pngObject);
    // }

    // function setPNG2(pngObject) {
    //     setCfgPNG(pngObject);
    // }

    const getPDFTemplate = (country) => {
        switch (country) {
            case "rs":
                return householdsReportSerbianPDF;
            case "fr":
                return householdsReportFrenchPDF;
            case "gb":
                return householdsReportEnglishPDF;
        }
    }

    async function generatePDF(investitor) {

        const formPdfBytes = await fetch(getPDFTemplate(props.country)).then(res => res.arrayBuffer());

        // Load a PDF with form fields
        const pdfDoc = await PDFDocument.load(formPdfBytes);

        // Set all available metadata fields on the PDFDocument. Note that these fields
        // are visible in the "Document Properties" section of most PDF readers.
        pdfDoc.setTitle(investitor)
        pdfDoc.setAuthor(investitor)
        pdfDoc.setSubject('Cost effectiveness study')
        pdfDoc.setKeywords(['solarlink', 'solar energy', 'calculation', 'report'])
        pdfDoc.setProducer('Solarlink - PDF Generator')
        pdfDoc.setCreator('Solarlink - https://solarlink.app')
        pdfDoc.setCreationDate(new Date())
        pdfDoc.setModificationDate(new Date())

        // Get Form
        const form = pdfDoc.getForm();

        let data = PDFService.householdsCalculatorPrepareData(recievedData, investitor);
        PDFService.householdsCalculatorFillTemplate(form, data);

        const imagePCG = await pdfDoc.embedPng(pcgPNG);
        const imageCFG = await pdfDoc.embedPng(cfgPNG);

        // Set Production Consumption graph
        const productionConsumptionField = form.getButton('energyGraphField');
        productionConsumptionField.setImage(imagePCG)

        // Set Cash Flow graph
        const cashFlowField = form.getButton('cashflowGraphField');
        cashFlowField.setImage(imageCFG)

        // Zakljucava polja forme da ne mogu da se menjaju
        form.flatten();

        // Crtanje slike na novoj stranici
        // const page = pdfDoc.addPage();
        // const pngDims = imagePCG.scaleToFit(900, 300);
        // page.drawImage(imagePCG, {
        //     x: page.getWidth() / 2 - pngDims.width / 2,
        //     y: page.getHeight() / 2 - pngDims.height / 2,
        //     width: pngDims.width,
        //     height: pngDims.height,
        // })

        // Save the modified PDF to a new buffer
        const pdfBytes = await pdfDoc.save();

        const bytes = new Uint8Array(pdfBytes);
        const blob = new Blob([bytes], { type: "application/pdf" });
        const docUrl = URL.createObjectURL(blob);

        window.open(docUrl);

    };

    return (
        <>
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={phase == "calculating"}
            >
                <CircularProgress color="inherit" />
            </Backdrop> */}
            {
                phase != "finished" &&
                <Box sx={{ width: '100%' }}>
                    <LinearProgress color='info' />
                </Box>
            }
            {
                phase == "finished" && recievedData != null &&
                <div id="basic-calculator-results">
                    <Row className="justify-content-center">
                        <h3 className="title text-center">
                          {t("stringsTranslations.results")}
                        </h3>
                        <div className='conclusion'>
                            {
                                CalculatorService.getConclusionText(recievedData.results.conclusion, recievedData)
                            }
                        </div>
                    </Row>
                    <Row>
                        {/* <Col xs="12" sm="12" md="12" lg="6" xl="6">
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 350 }} aria-label="caption table">
                                    <caption>Results per month</caption>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Month</TableCell>
                                            <TableCell align="right">E_m (kWh)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {recievedData["results"]["months"].map((m) => (
                                            <TableRow key={m["month"]}>
                                                <TableCell component="th" scope="row">
                                                    {m["month"]}
                                                </TableCell>
                                                <TableCell align="right">{m["E_m"]}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Col> */}
                        <Col xs="12" sm="12" md="12" lg="6" xl="6" style={{ marginBottom: "50px" }}>
                            <TableContainer component={Paper}>
                                <Table aria-label="caption table">
                                    {/* <caption>* Shouldn't be displayed. Displaying only for testing purposes</caption> */}
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Ulazni podaci</TableCell>
                                            <TableCell align="right">Vrednosti</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow key="coordinates">
                                            <TableCell component="th" scope="lat">
                                             {t("stringsTranslations.coordinates")}
                                            </TableCell>
                                            <TableCell align="right">
                                                {MainService.degToDMS(recievedData["inputs"]["lat"])}, {MainService.degToDMS(recievedData["inputs"]["lon"])}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key="aspect">
                                            <TableCell component="th" scope="row">
                                             {t("stringsTranslations.azimuthAngle")}
                                            </TableCell>
                                            <TableCell align="right">
                                                {recievedData["inputs"]["aspect"]}°
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key="angle">
                                            <TableCell component="th" scope="row">
                                               {t("stringsTranslations.tiltAngle")}
                                            </TableCell>
                                            <TableCell align="right">
                                                {recievedData["inputs"]["angle"]}°
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key="roof_area">
                                            <TableCell component="th" scope="row">
                                                {t("stringsTranslations.freeRoofArea")}
                                            </TableCell>
                                            <TableCell align="right">
                                                {recievedData["inputs"]["roof_area"]}m²
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key="consumption">
                                            <TableCell component="th" scope="row">
                                             {t("stringsTranslations.maximumAuthorizedPower")}
                                            </TableCell>
                                            <TableCell align="right">
                                                {recievedData["inputs"]["consumption"]}kWh
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Col>
                        <Col xs="12" sm="12" md="12" lg="6" xl="6" className='cash-flow-graph'>
                            <CashFlowGraph
                                data={prepareDataForCashFlowDiagram(recievedData["results"]["bilance"])}
                                setPNG={setCfgPNG}
                            />
                        </Col>
                    </Row>
                    <Row className='production-consumption-graph' style={{ marginTop: "50px" }}>
                        <ProductionConsumptionGraph
                            data={recievedData}
                            setPNG={setPcgPNG}
                        />
                    </Row>

                    {
                        pcgPNG != undefined && cfgPNG != undefined &&
                        <ResultsModal generatePDF={generatePDF} />
                    }

                </div>
            }
        </>
    );
}

export default HouseholdsResults;